<template>
  <MainHeader />
  <MainSidebar />
  <div
    class="main-content bg_gray d-flex flex-column transition overflow-hidden"
  >
    <BreadcrumbMenu pageTitle="expense_list" />
    <FilterContent 
      btnText="expenses" 
      btnLink="/create-expense" 
      @filter="handleFilter"
      @export-excel="handleExport"
    />
    <ExpensesList 
      ref="expensesListRef"
      :search-query="searchQuery"
      :filters="filters"
      @view-details="openDetailsModal" 
    />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>

  <div
    class="delete-popup offcanvas offcanvas-end border-0"
    tabindex="-1"
    id="deletePopup"
  >
    <div class="offcanvas-body p-0">
      <div class="delete-success">
        <img src="../../assets/img/icons/tick-circle.svg" alt="Image" />
        <span class="text-white fw-medium">
          {{ $t("expense_page.expense_deleted_from_list") }}
        </span>
      </div>
    </div>
  </div>
  <DetailsModal :expense="selectedExpense" />
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import FilterContent from "../../components/Expenses/ExpensesList/FilterContent.vue";
import ExpensesList from "../../components/Expenses/ExpensesList/ExpensesList.vue";
import DetailsModal from "../../components/Expenses/ExpensesList/DetailsModal.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import type { ExpenseFilters } from "../../services/expense";

export default defineComponent({
  name: "ExpensesListPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    FilterContent,
    ExpensesList,
    DetailsModal,
    MainFooter,
  },
  setup() {
    const selectedExpense = ref<any>(null);
    const searchQuery = ref("");
    const expensesListRef = ref<any>(null);
    const filters = reactive<ExpenseFilters>({
      warehouse_id: "",
      category_id: "",
      from_date: "",
      to_date: "",
    });

    const openDetailsModal = (expense: any) => {
      selectedExpense.value = expense;
    };

    const handleFilter = (payload: ExpenseFilters) => {
      searchQuery.value = payload.q ?? payload.search ?? "";
      filters.warehouse_id = payload.warehouse_id ?? "";
      filters.category_id = payload.category_id ?? "";
      filters.from_date = payload.from_date ?? "";
      filters.to_date = payload.to_date ?? "";
    };

    const handleExport = () => {
      if (expensesListRef.value) {
        expensesListRef.value.exportExcel();
      }
    };

    return {
      selectedExpense,
      openDetailsModal,
      searchQuery,
      handleFilter,
      handleExport,
      expensesListRef,
      filters,
    };
  },
});
</script>
